// Named constants for the Expert Chats oversight pages. Enum values mirror the
// Django backend (api-django/frontera/api/enum/chat_enums.py); update both when
// the backend adds a value.
import { ListExpertChatsStatus } from "@api/rest/types-and-hooks";

export const ExpertChatStatus = {
  OPEN: ListExpertChatsStatus.OPEN,
  FINISHED: ListExpertChatsStatus.FINISHED,
} as const;
export type ExpertChatStatusValue = (typeof ExpertChatStatus)[keyof typeof ExpertChatStatus];

export const EXPERT_CHAT_STATUS_LABELS: Record<ExpertChatStatusValue, string> = {
  [ExpertChatStatus.OPEN]: "Open",
  [ExpertChatStatus.FINISHED]: "Archived",
};

export const STATUS_FILTER_ITEMS = [
  { id: ExpertChatStatus.OPEN, label: EXPERT_CHAT_STATUS_LABELS[ExpertChatStatus.OPEN] },
  { id: ExpertChatStatus.FINISHED, label: EXPERT_CHAT_STATUS_LABELS[ExpertChatStatus.FINISHED] },
];

export const UNASSIGNED_PROVIDER_LABEL = "Unassigned";

export const EXPERT_CHATS_PAGE_SIZE = 25;
export const EXPERT_CHATS_PAGE_SIZE_OPTIONS = [10, 25, 50];

// The roster is resolved through the Auth0 Management API server-side, so it is
// slow and effectively static across a session.
export const PROVIDER_STALE_TIME_MS = 15 * 60 * 1000;

export const SEARCH_DEBOUNCE_MS = 200;

export const EXPERT_CHAT_MESSAGE_PAGE_SIZE = 50;

// Distance from the top of the transcript that triggers loading the page of
// older messages.
export const LOAD_OLDER_THRESHOLD_PX = 120;
